var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86024 16.9057C3.3096 17.1259 3.85602 16.9474 4.08071 16.5071C5.96691 12.8118 7.80441 10.8378 11.1569 8.99759C11.68 8.71048 12.3201 8.71048 12.8431 8.99759C16.1957 10.8378 18.0332 12.8118 19.9193 16.5071C20.144 16.9474 20.6905 17.1259 21.1399 16.9057C21.5892 16.6856 21.7713 16.1504 21.5466 15.7102C19.5182 11.736 17.441 9.47842 13.7325 7.44279C12.6569 6.8524 11.3431 6.8524 10.2676 7.44279C6.55903 9.47842 4.48188 11.736 2.45342 15.7102C2.22873 16.1504 2.41087 16.6856 2.86024 16.9057Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-Up.1fa6e580.svg";
export { ForwardRef as ReactComponent };